
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  // Calculate age dynamically
  const calculateAge = () => {
    const birthDate = new Date(1999, 9, 1); // October 1, 1999 (month is 0-indexed)
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // Calculate experience dynamically
  const calculateExperience = () => {
    const startDate = new Date(2024, 3, 1); // April 1, 2024 (month is 0-indexed)
    const today = new Date();
    let years = today.getFullYear() - startDate.getFullYear();
    let months = today.getMonth() - startDate.getMonth();
    
    if (months < 0) {
      years--;
      months += 12;
    }
    
    if (years === 0) {
      return `${months}개월`;
    } else if (months === 0) {
      return `${years}년`;
    } else {
      return `${years}년 ${months}개월`;
    }
  };

  const age = calculateAge();
  const experience = calculateExperience();

  const handleEmailClick = async () => {
    const email = 'jisung.develop@gmail.com';
    try {
      await navigator.clipboard.writeText(email);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    } catch (err) {
      // 클립보드 API가 지원되지 않는 경우 fallback
      const textArea = document.createElement('textarea');
      textArea.value = email;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 2000);
      } catch (fallbackErr) {
        console.error('복사 실패:', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  const handleGithubClick = () => {
    window.open('https://github.com/zzzzseong', '_blank');
  };

  const handleBlogClick = () => {
    window.open('https://zzzzseong.tistory.com/', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Grid Pattern */}
        <div className="absolute inset-0 opacity-[0.15]" style={{
          backgroundImage: `
            linear-gradient(rgba(62, 207, 142, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(62, 207, 142, 0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }} />
        
        {/* Gradient Orbs */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#3ECF8E]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#2dd4bf]/10 rounded-full blur-3xl" />
      </div>

      <div className={`relative z-10 text-center max-w-5xl mx-auto transition-all duration-1000 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}>
        {/* Main Headline */}
        <div className="mb-10">
          <h1 className="text-7xl md:text-8xl font-bold mb-4 bg-gradient-to-r from-white via-[#3ECF8E] to-white bg-clip-text text-transparent tracking-tight font-montserrat leading-tight pb-2">
            Jung Jisung
          </h1>
          
          {/* Role - Elegant Typography */}
          {/* <div className="flex items-center justify-center gap-4">
            <div className="h-px bg-gradient-to-r from-transparent via-[#3ECF8E]/50 to-transparent flex-1 max-w-16" />
            <h2 className="text-2xl md:text-3xl font-light text-[#3ECF8E] font-montserrat tracking-wider uppercase">
              Backend Developer
            </h2>
            <div className="h-px bg-gradient-to-r from-transparent via-[#3ECF8E]/50 to-transparent flex-1 max-w-16" />
          </div> */}
        </div>

        {/* Subtext - Tags */}
        <div className="mb-12 flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {['MSA 기반 메시징 시스템', 'API 서비스', '신규 웹서비스', '이벤트 기반 시스템', '대용량 트래픽 처리'].map((tag, index) => (
            <span
              key={index}
              className="px-4 py-2 bg-[#161b22]/60 backdrop-blur-sm border border-[#30363d] hover:border-[#3ECF8E]/50 rounded-lg text-sm md:text-base text-gray-300 hover:text-[#3ECF8E] transition-all duration-300 hover:shadow-md hover:shadow-[#3ECF8E]/10"
            >
              {tag}
            </span>
          ))}
        </div>

        {/* Code-like motif */}
        <div className="mb-12 font-mono text-xs md:text-sm text-gray-400 bg-[#161b22]/80 backdrop-blur-sm border border-[#30363d] rounded-xl p-6 max-w-2xl mx-auto hover:border-[#3ECF8E]/30 transition-all duration-300">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-2.5 h-2.5 rounded-full bg-red-500/80" />
            <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/80" />
            <div className="w-2.5 h-2.5 rounded-full bg-green-500/80" />
            <span className="ml-2 text-xs text-gray-500">BackendService.java</span>
          </div>
          <div className="text-left space-y-1">
            <div>
              <span className="text-purple-400 font-montserrat">@Service</span>
            </div>
            <div>
              <span className="text-blue-400 font-montserrat">public class</span>{' '}
              <span className="text-yellow-400 font-montserrat">BackendService</span>{' '}
              <span className="text-orange-400">{'{'}</span>
            </div>
            <div className="ml-4">
              <span className="text-blue-400 font-montserrat">private</span>{' '}
              <span className="text-cyan-400 font-montserrat">String</span>{' '}
              <span className="text-white font-montserrat">name</span>{' '}
              <span className="text-gray-500">=</span>{' '}
              <span className="text-green-400 font-montserrat">"Jung Jisung"</span>
              <span className="text-gray-500">;</span>
            </div>
            <div className="ml-4">
              <span className="text-blue-400 font-montserrat">private</span>{' '}
              <span className="text-cyan-400 font-montserrat">String</span>{' '}
              <span className="text-white font-montserrat">role</span>{' '}
              <span className="text-gray-500">=</span>{' '}
              <span className="text-green-400 font-montserrat">"Backend Developer"</span>
              <span className="text-gray-500">;</span>
            </div>
            <div className="ml-4">
              <span className="text-blue-400 font-montserrat">private</span>{' '}
              <span className="text-cyan-400 font-montserrat">int</span>{' '}
              <span className="text-white font-montserrat">age</span>{' '}
              <span className="text-gray-500">=</span>{' '}
              <span className="text-green-400 font-montserrat">{age}</span>
              <span className="text-gray-500">;</span>
            </div>
            <div className="ml-4">
              <span className="text-blue-400 font-montserrat">private</span>{' '}
              <span className="text-cyan-400 font-montserrat">String</span>{' '}
              <span className="text-white font-montserrat">experience</span>{' '}
              <span className="text-gray-500">=</span>{' '}
              <span className="text-green-400 font-montserrat">"{experience}"</span>
              <span className="text-gray-500">;</span>
            </div>
            <div>
              <span className="text-orange-400">{'}'}</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap justify-center gap-4">
          <button
            onClick={handleGithubClick}
            className="group flex items-center gap-2.5 px-6 py-3 bg-[#161b22]/80 backdrop-blur-sm hover:bg-[#21262d] border border-[#30363d] hover:border-[#3ECF8E] rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-[#3ECF8E]/20 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-github-fill text-lg group-hover:text-[#3ECF8E] transition-colors" />
            <span className="font-medium text-sm font-montserrat">GitHub</span>
          </button>
          
          <button
            onClick={handleBlogClick}
            className="group flex items-center gap-2.5 px-6 py-3 bg-[#161b22]/80 backdrop-blur-sm hover:bg-[#21262d] border border-[#30363d] hover:border-[#3ECF8E] rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-[#3ECF8E]/20 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-article-line text-lg group-hover:text-[#3ECF8E] transition-colors" />
            <span className="font-medium text-sm font-montserrat">Blog</span>
          </button>
          
          <button
            onClick={handleEmailClick}
            className="group flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-[#3ECF8E] to-[#2dd4bf] hover:from-[#2dd4bf] hover:to-[#3ECF8E] text-black rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-[#3ECF8E]/40 whitespace-nowrap cursor-pointer font-semibold text-sm font-montserrat"
          >
            <i className="ri-mail-line text-lg" />
            <span>Contact</span>
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#3ECF8E] rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#3ECF8E] rounded-full mt-2 animate-pulse" />
        </div>
      </div>

      {/* Toast Notification */}
      {showToast && (
        <div className="fixed top-8 left-1/2 -translate-x-1/2 z-50 animate-toast-slide-in">
          <div className="relative bg-gradient-to-br from-[#161b22] via-[#0d1117] to-[#161b22] border border-[#3ECF8E]/50 rounded-xl px-6 py-4 shadow-2xl shadow-[#3ECF8E]/20 backdrop-blur-sm">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#3ECF8E]/10 via-transparent to-[#2dd4bf]/10 rounded-xl blur-sm" />
            
            <div className="relative flex items-start gap-4">
              {/* Icon with animation */}
              <div className="flex-shrink-0 mt-0.5">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#3ECF8E] to-[#2dd4bf] flex items-center justify-center shadow-lg shadow-[#3ECF8E]/30">
                  <i className="ri-checkbox-circle-fill text-white text-xl animate-icon-bounce" />
                </div>
              </div>
              
              {/* Content */}
              <div className="flex flex-col gap-2 flex-1">
                <span className="text-white font-semibold text-base">이메일 주소가 복사되었습니다!</span>
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line text-[#3ECF8E] text-sm" />
                  <span className="text-[#3ECF8E] font-mono text-sm font-medium tracking-wide">jisung.develop@gmail.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
